import React, { useEffect } from 'react'
import { createLessonAPIEndpoint, EndPoints } from '../../../services/LessonServices';
import LessonCard from '../components/LessonCard';
import { Box } from '@mui/material';

function MyLessons() {
 const [lessons, setLessons] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    createLessonAPIEndpoint(EndPoints.myLessons)
    .fetch()
    .then((res) => {
      console.log("Lessons fetched successfully:", res.data);
      setLessons(res.data);
      setLoading(false);
    }).catch((error) => {
      console.error("Error fetching lessons:", error);
      setLoading(false);
    });
  }, []);
  return (
    <>
      <section className="section courses">
        <div className="container">
          {loading ? (
            <div className="loading">Loading lessons...</div>): lessons.length === 0 ? (
            <div className="no-lessons">No lessons available at the moment.</div>) : 
            (<Box className="lesson-grid">
              {lessons.map((lesson) => (
                <LessonCard key={lesson.id} lesson={lesson} />
              ))}
            </Box>)}
        </div>
      </section>
    </>
  );
}

export default MyLessons